/**
 * 客製化 $fetch
 *
 * @returns $customFetch
 */

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig();
  const { API_DOMAIN } = runtimeConfig.public;
  const profileStore = useProfileStore();

  const customFetch = $fetch.create({
    baseURL: API_DOMAIN,
    onRequest({ options }) {
      options.credentials = 'include';
    },
    async onResponseError({ response }) {
      const { status } = response;

      if (status === 401) {
        if (import.meta.client) {
          const callbackUrl = window.location.href;
          profileStore.HANDLE_LOGIN(callbackUrl);
        } else {
          const loginUrl = profileStore.HANDLE_LOGIN();
          await nuxtApp.runWithContext(() =>
            navigateTo(loginUrl, { external: true })
          );
        }
      }

      return Promise.reject(response._data);
    },
  });

  return {
    provide: { customFetch },
  };
});
